/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Lifecycle_Unarchived_ToastInputs */

const en_lifecycle_unarchived_toast = /** @type {(inputs: Lifecycle_Unarchived_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} unarchived`)
};

const de_lifecycle_unarchived_toast = /** @type {(inputs: Lifecycle_Unarchived_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} aus dem Archiv geholt`)
};

/**
* | output |
* | --- |
* | "{name} unarchived" |
*
* @param {Lifecycle_Unarchived_ToastInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_unarchived_toast = /** @type {((inputs: Lifecycle_Unarchived_ToastInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Unarchived_ToastInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_unarchived_toast(inputs)
	return en_lifecycle_unarchived_toast(inputs)
});